const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Toggle Accordion on the product page
 */
const AccordionToggle = {

    init() { 

        $('.accordion-target').on('click', function() {
            $(this).next('.accordion-content').slideToggle('300');
            $(this).toggleClass('open');
        });

        $('#wpsl-wrap .wpsl-search').remove();

        var check = document.getElementById("spareParchment");

        if(check) {
            function updateWidth() {
                var changeMe = document.getElementById("spareParchment");
                var myDiv = document.getElementById("mainContainer");
                var newWidth = ((window.innerWidth - myDiv.offsetWidth) / 2) + 1;
                changeMe.style.width = newWidth + "px";
            }
            
            window.addEventListener("resize", updateWidth);
            updateWidth();
        }
    }
};

export default AccordionToggle;